/* eslint-disable import/no-extraneous-dependencies */
import { applyMiddleware, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import loggerMiddleware from "../logger";
import createRootReducer from "../createRootReducer"; // remove 'history' dependency here if used

const configureStore = preloadedState => {
  const middlewares = [loggerMiddleware, thunkMiddleware];

  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const composedEnhancers = composeEnhancers(...enhancers);
  const rootReducer = createRootReducer(); // 🚨 remove history argument
  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  return store;
};

export default configureStore;
